import React from 'react';
import { formatText, HtmlText } from 'core/i18n';
import { Instruction } from './Instruction';
import './InstructionList.scss';
import { isMobile } from 'utilities/browser';
import PropTypes from 'prop-types';
import MessageBox from 'components/commons/MessageBox/MessageBox';

export const InstructionsList = ({ instructions, showVideoPermissionAdvise }) => {
    const areAllInstructionsHidden = instructions.every(instruction => instruction.hiddenInMobile === isMobile());

    const renderVideoPermissionAdvise = () => {
        return (
            <MessageBox
                titleText={formatText('identity-videoPermissionAdviseTitle')}
                contentText={HtmlText(formatText('identity-videoPermissionAdviseContent'))}
            />
        );
    };

    if (areAllInstructionsHidden) {
        return showVideoPermissionAdvise ? renderVideoPermissionAdvise() : null;
    }

    return (
        <div className="video-iten-description">
            <p className="font-heading3">{formatText('identity-videoDocsTitle')}</p>
            {showVideoPermissionAdvise && renderVideoPermissionAdvise()}
            <ul className={'instruction-list check-list'}>
                {instructions.map(({ title, text, hiddenInMobile }, index) =>
                    isMobile() && hiddenInMobile ? null : <Instruction title={title} text={text} key={index} />
                )}
            </ul>
        </div>
    );
};

InstructionsList.propTypes = {
    instructions: PropTypes.array,
};
